import { useState } from "react";
import {
  Modal,
  Button,
  Typography,
  Tooltip,
  message,
  notification,
  Input,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { IoCloseSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { actions } from "../slice";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const { Title, Text } = Typography;

function DeleteKit({ KitDetail, disabledActions }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [reason, setReason] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    if (!reason.trim()) {
      message.error("Please provide a reason for deletion.");
      return;
    }
    const data = {
      samplerKitId: KitDetail?._id,
      reason: reason,
    };

    setLoading(true);
    dispatch(
      actions.deleteKit({
        data,
        onSuccess: () => {
          notification.success({
            message: "Kit Deleted Successfully",
          });
          history.goBack();
          handleCancel();
        },
        onFailure: (error) => {
          setLoading(false);
          notification.error({
            message: error?.message || "Failed to delete the kit",
          });
        },
      })
    );
  };

  const handleCancel = () => {
    setLoading(false);
    setIsModalOpen(false);
    setReason("");
  };

  return (
    <>
      <Tooltip
        title={
          disabledActions
            ? "Kit deletion is only allowed in the Pending or Packed stage"
            : "Delete this kit and all its associated assets."
        }
      >
        <Button
          type="primary"
          icon={<DeleteOutlined />}
          onClick={() => {
            setIsModalOpen(true);
          }}
          disabled={disabledActions}
          style={{
            backgroundColor: disabledActions ? undefined : "#d32f2f",
            borderColor: disabledActions ? undefined : "#d32f2f",
          }}
        >
          Delete Kit
        </Button>
      </Tooltip>
      <Modal
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button
            type="primary"
            onClick={handleDelete}
            style={{
              minWidth: 80,
              backgroundColor: disabledActions ? undefined : "#d32f2f",
              borderColor: disabledActions ? undefined : "#d32f2f",
            }}
            loading={loading}
          >
            Yes
          </Button>,
          <Button onClick={handleCancel} style={{ minWidth: 80 }}>
            No
          </Button>,
        ]}
        width={500}
        bodyStyle={{ borderRadius: 16, padding: 24, background: "#fff" }}
        style={{ borderRadius: 16 }}
        closeIcon={<IoCloseSharp size="24" />}
        centered
        className="modal-content"
      >
        <Title level={4} style={{ fontWeight: 700, marginBottom: 15 }}>
          Are you sure you want to delete?
        </Title>
        <div style={{ marginBottom: 20 }}>
          <Text
            style={{
              fontWeight: 600,
              color: "#232A36",
              display: "block",
              marginBottom: 8,
            }}
          >
            Reason for Deletion <span style={{ color: "#FF4D4F" }}>*</span>
          </Text>
          <Input
            placeholder="Enter reason for deleting this kit"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={{ width: "100%" }}
            size="large"
          />
        </div>
      </Modal>
    </>
  );
}

export default DeleteKit;
